
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.125","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9 3.938V.562M5.42 5.42L3.034 3.034M3.938 9H.562M5.42 12.58l-2.386 2.386M9 14.063v3.374M12.58 12.58l2.386 2.386M14.063 9h3.374M12.58 5.42l2.386-2.386M3.938 9a5.062 5.062 0 1010.124 0A5.062 5.062 0 003.938 9z"}})])])
          )
        }
      }
    